
const digest = 'cb38305470dabd5fd014afea9b1aba2d445e5dc1fc2e43bc4081c3a11c2cd9c2';
const classes = {"wrapper":"_wrapper_1q8kc_1","label":"_label_1q8kc_5","expanded":"_expanded_1q8kc_10","item":"_item_1q8kc_20"};
const css = `._wrapper_1q8kc_1 {
  position: relative;
  font-family: Rubik, "sans-serif";
}
._wrapper_1q8kc_1 ._label_1q8kc_5 {
  padding: 12px;
  font-size: 12px;
}

._expanded_1q8kc_10 {
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.1);
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100%;
}
._expanded_1q8kc_10 ._item_1q8kc_20 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  font-weight: 600;
  padding: 6px 12px;
  border-bottom: 1px solid #ffffff;
  font-size: 12px;
}
._expanded_1q8kc_10 ._item_1q8kc_20:last-of-type {
  border-bottom: none;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  